<template>
  <div class="center">
    <!-- 查询区域 -->
    <section class="select">
      <div class="left">
        <Input
          v-model="selectData.keyword"
          placeholder="配件编码/配件名称"
          class="w250"
        ></Input>

        <Select
          label-in-value
          v-model="selectData.partsType"
          placeholder="配件类型"
          @on-change="typeChange"
          class="w150"
        >
          <Option
            v-for="item in partsTypeList"
            :value="item.value"
            :key="item.value"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          label-in-value
          v-model="selectData.carBrandId"
          placeholder="品牌"
          class="w150"
          filterable
        >
          <Option
            v-for="item in carBrandIdList"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          label-in-value
          v-model="selectData.shelfStatus"
          placeholder="商品状态"
          class="w150"
        >
          <Option
            v-for="item in shelfStatusList"
            :value="item.itemValueOne"
            :key="item.itemValueOne"
            >{{ item.itemName }}</Option
          >
        </Select>
        <Button
          style="margin-left: 10px"
          type="primary"
          @click="selectEvent()"
          :loading="selectLoading"
          >搜索</Button
        >
        <Button style="margin-left: 10px" type="primary" @click="reset()"
          >重置</Button
        >
      </div>
    </section>
    <!-- 按钮区域 -->
    <div class="right_btn">
      <div class="BtnArea" style="minwidth: 600px" v-if="tenantType == 3">
        <Button type="primary" @click="addGoodsEvent">新增</Button>
        <Button type="primary" @click="putaway" :loading="putawayLoading"
          >上架</Button
        >
        <Button type="primary" @click="soldout" :loading="soldoutLoading"
          >下架</Button
        >
        <Button type="primary" @click="exportExcel" :loading="exportLoading"
          >导出
        </Button>
        <Button type="primary" @click="Batchadd">批量新增商品</Button>
        <Button type="primary" @click="batchclick"
          >批量修改库存及货架状态</Button
        >
      </div>
      <div class="BtnArea" style="margin-right: 10px">
        <Button type="primary" @click="ERRopen" v-has="'WSS-4001-erpGDS'"
          >ERP同步商品</Button
        >
        <Button type="primary" @click="overallset">全局设置</Button>
      </div>
    </div>

    <div class="table">
      <!-- 表格主体 -->
      <vxe-table
        border
        resizable
        :max-height="screenHeight"
        show-header-overflow
        show-overflow
        highlight-hover-row
        align="center"
        style="width: 98%; margin: 0 auto"
        ref="tableData"
        :loading="tableLoading"
        :data="tableData"
        :checkbox-config="{ trigger: 'row' }"
        :sort-config="{
          multiple: true,
          trigger: 'cell',
          remote: true,
          iconAsc: 'ivu-icon ivu-icon-ios-arrow-up',
          iconDesc: 'ivu-icon ivu-icon-ios-arrow-down'
        }"
        @sort-change="sortChangeEvent"
      >
        <vxe-column
          type="checkbox"
          title="选择"
          v-if="tenantType == 3"
          minWidth="100"
          fixed="left"
        ></vxe-column>
        <vxe-column
          title="操作"
          minWidth="100"
          fixed="left"
          v-if="tenantType == 3"
        >
          <template #default="{ row }">
            <span @click="goEditPage(row)" class="editBtn">编辑商品</span>
          </template>
        </vxe-column>

        <vxe-column
          minWidth="150"
          field="oeCode"
          fixed="left"
          title="配件编码"
        ></vxe-column>
        <vxe-column
          minWidth="150"
          field="fullName"
          fixed="left"
          title="配件名称"
        ></vxe-column>
        <vxe-column
          minWidth="150"
          field="typeName"
          fixed="left"
          title="配件类型"
        >
        </vxe-column>
        <vxe-column
          minWidth="150"
          field="carBrandName"
          title="品牌"
        ></vxe-column>

        <vxe-column
          minWidth="150"
          field="shelvesState"
          title="商品状态"
        ></vxe-column>
        <vxe-column
          minWidth="250"
          field="sellingPrice"
          sortable
          title="价格（元）"
          class="price"
        >
          <template #default="{ row }">
            <span>{{
              row.sellingPrice == 'null' ? '暂无' : row.sellingPrice
            }}</span>
            <!-- <Icon
            type="ios-create-outline"
            @click="editPrice(row)"
            v-if="tenantType == 3"
            size="20"
            color="#2d8cf0"
          /> -->
            <span
              class="iconfont icon-bianji"
              v-if="tenantType == 3"
              @click="editPrice(row)"
            ></span>
          </template>
        </vxe-column>

        <vxe-column minWidth="150" field="stock" sortable title="库存数量">
          <template #default="{ row }">
            <span>{{ row.stock }}</span>
            <!-- <Icon
            v-if="tenantType == 3"
            type="ios-create-outline"
            @click="editStock(row)"
            size="20"
            color="#2d8cf0"
          /> -->
            <span
              class="iconfont icon-bianji"
              v-if="tenantType == 3"
              @click="editStock(row)"
            ></span>
          </template>
        </vxe-column>
        <vxe-column
          minWidth="150"
          field="salesVolume"
          sortable
          title="销量"
        ></vxe-column>
        <vxe-column minWidth="250" field="create" title="创建信息">
          <template #default="{ row }">
            <div>{{ row.createUname }}</div>
            <div>{{ row.createTime }}</div>
          </template></vxe-column
        >
        <vxe-column minWidth="250" field="update" title="修改信息">
          <template #default="{ row }">
            <div>{{ row.updateUname }}</div>
            <div>{{ row.updateTime }}</div>
          </template></vxe-column
        >
      </vxe-table>
      <!-- 分页 -->
      <div style="minwidth: 600px">
        <!-- <vxe-pager
          background
          align="right "
          :page-sizes="[30]"
          size="medium"
          :current-page.sync="pager.current"
          :page-size.sync="pager.size"
          :total="pager.total"
          @page-change="handlePageChange"
          :layouts="[
            'PrevJump',
            'PrevPage',
            'Number',
            'NextPage',
            'NextJump',
            'Sizes',
            'FullJump',
            'Total'
          ]"
        >
          >
        </vxe-pager> -->

        <div style="display: flex; justify-content: right; padding-right: 16px">
          <vxe-pager
            background
            align="right "
            :page-sizes="[30]"
            size="medium"
            :current-page.sync="pager.current"
            :page-size.sync="pager.size"
            :total="pager.total"
            @page-change="handlePageChange"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'Number',
              'NextPage',
              'NextJump',
              'Sizes',
              'FullJump',
              'Total'
            ]"
          >
          </vxe-pager>
          <span
            style="
              height: 31px;
              padding: 7px 10px;
              border: 1px solid rgb(220, 222, 226);
              border-radius: 4px;
              margin-top: 8px;
              line-height: 13px;
            "
            >30条/页</span
          >
        </div>
      </div>
    </div>
    <!-- 外部价格编辑 -->
    <Modal
      v-if="tenantType == 3"
      v-model="priceEdit"
      width="650"
      title="编辑商品价格"
      :mask-closable="false"
    >
      <Form
        ref="priceForm"
        :model="priceForm"
        :rules="priceRoules"
        :label-width="100"
      >
        <FormItem label="价格类型：" prop="priceType">
          <RadioGroup v-model="priceForm.priceType" @on-change="changeRadio">
            <Radio label="0">一口价</Radio>
            <Radio label="1">阶梯价格</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="价格：" prop="price">
          <ul class="priceType" v-if="priceForm.priceType == 1">
            <li v-for="(item, index) in priceForm.priceListOne" :key="index">
              <div>{{ index == 0 ? '起订量' : '购买' }}</div>
              <Input
                v-model="item.orderQuantity"
                placeholder="数量..."
                @on-focus="priceEvent(index)"
                size="small"
                style="width: 100px"
              />个单位及以上
              <Input
                v-model="item.price"
                placeholder="价格..."
                size="small"
                style="width: 100px"
              />元/单位
              <Icon
                v-if="index !== 0"
                type="md-remove-circle"
                color="#e90d0d"
                size="16"
                class="removeBtn"
                @click="priceDel(index)"
              />
            </li>
            <li class="maxTip" v-if="priceForm.priceListOne.length >= 5">
              <Icon type="ios-alert-outline" size="20" color="#0074ff" />
              <span>最多只能添加5次</span>
            </li>
          </ul>
          <ul class="priceType" v-else>
            <li v-for="(item, index) in priceForm.priceListZero" :key="index">
              <Input
                v-model="item.price"
                placeholder="价格..."
                size="small"
                style="width: 100px"
              />元/单位
            </li>
          </ul>
        </FormItem>
      </Form>
      <div slot="footer" class="footer">
        <Button type="primary" @click="priceOk" :loading="priceOkLoading"
          >确认</Button
        >
        <Button @click="priceCancel">取消</Button>
      </div>
    </Modal>
    <!-- 佳配连锁价格管理 -->
    <Modal
      v-else
      v-model="priceEdit"
      width="650"
      title="编辑商品价格"
      :mask-closable="false"
    >
      <Form
        ref="priceForm"
        :model="priceForm"
        :rules="priceRoules"
        :label-width="100"
      >
        <FormItem label="价格类型：">
          <RadioGroup v-model="priceForm.priceType">
            <Radio label="0" disabled>一口价</Radio>
            <Radio label="1" disabled>阶梯价格</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="价格：">
          <ul class="priceType" v-if="priceForm.priceType == 1">
            <li v-for="(item, index) in priceForm.priceListOne" :key="index">
              <div>{{ index == 0 ? '起订量' : '购买' }}</div>
              <Input
                v-model="item.orderQuantity"
                placeholder="数量..."
                size="small"
                style="width: 100px"
                disabled
              />个单位及以上
              <Input
                v-model="item.price"
                placeholder="价格..."
                size="small"
                style="width: 100px"
                disabled
              />元/单位
            </li>
          </ul>
          <ul class="priceType" v-else>
            <li v-for="(item, index) in priceForm.priceListZero" :key="index">
              <Input
                v-model="item.price"
                placeholder="价格..."
                size="small"
                style="width: 100px"
              />元/单位
            </li>
          </ul>
        </FormItem>
      </Form>
      <div slot="footer" class="footer">
        <Button @click="priceCancel">取消</Button>
      </div>
    </Modal>
    <!-- 库存编辑 -->
    <Modal
      width="400"
      v-model="stockEdit"
      title="编辑库存"
      :mask-closable="false"
    >
      <Form
        ref="stockForm"
        :model="stockForm"
        :rules="stockRoules"
        :label-width="90"
        class="app"
      >
        <FormItem label="商品名称："
          ><span>{{ this.stockForm.name }}</span>
        </FormItem>
        <FormItem label="库存：" prop="stock">
          <Input
            style="width: 200px"
            v-model="stockForm.stock"
            placeholder="输入库存数量"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer" class="footer">
        <Button type="primary" @click="stockOk" :loading="stockOkLoading"
          >确认</Button
        >
        <Button @click="stockCancel">取消</Button>
      </div>
    </Modal>
    <!-- 新增商品 -->
    <Modal
      v-model="addGoods"
      title="新增配件"
      max-hight="500"
      :mask-closable="false"
      width="1200"
    >
      <div class="addTop">
        <div class="left">
          <Form
            ref="addForm"
            :label-width="15"
            :model="addSelectData"
            :rules="addRules"
            class="addForm"
          >
            <Form-item label=" " prop="partsType">
              <Select
                label-in-value
                v-model="addSelectData.partsType"
                @on-change="addTypeChange"
                placeholder="配件类型"
                size="small"
                class="w150"
              >
                <Option
                  v-for="item in partsTypeList"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select>
            </Form-item>
            <Form-item label=" " prop="carBrandId">
              <Select
                filterable
                label-in-value
                v-model="addSelectData.carBrandId"
                placeholder="品牌"
                size="small"
                class="w150"
              >
                <Option
                  v-for="item in addPartsTypeList"
                  :value="item.name"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </Form-item>
            <Form-item label=" " prop="keyword">
              <Input
                v-model="addSelectData.keyword"
                placeholder="配件编码/配件名称"
                size="small"
                class="w200"
              ></Input>
            </Form-item>
          </Form>
        </div>
        <Button
          type="primary"
          size="small"
          @click="getMatchingData"
          :loading="matchLoading"
          >匹配平台库</Button
        >
      </div>
      <div class="addBottom" v-if="addStatus == 1">
        <!-- <div class="addImg">
          <img
            v-if="addStatus == 0"
            src="@/assets/images/myweb/goodsManagementAddBG.png"
            alt=""
          />
        </div> -->
        <div>
          <vxe-table
            border
            show-header-overflow
            show-overflow
            align="center"
            size="mini"
            max-height="400"
            :loading="addTableLoading"
            :row-config="{ isHover: true }"
            :data="addTableData"
          >
            <vxe-column title="操作" minWidth="100" fixed="left">
              <template #default="{ row }">
                <span @click="addSelectEvent(row)" class="selectListBtn"
                  >选择</span
                >
              </template>
            </vxe-column>
            <vxe-column
              minWidth="150"
              field="oeCode"
              fixed="left"
              title="配件编码"
            ></vxe-column>
            <vxe-column
              minWidth="100"
              field="qualityTypeId.name"
              fixed="left"
              title="配件类型"
            ></vxe-column>
            <vxe-column
              minWidth="150"
              field="carBrandName"
              fixed="left"
              title="品牌"
            ></vxe-column>
            <vxe-column
              minWidth="150"
              field="fullName"
              fixed="left"
              title="配件名称"
            ></vxe-column>
            <vxe-column
              minWidth="250"
              field="oeCodeSuitable"
              title="关联原厂件OEM"
            ></vxe-column>
            <vxe-column
              minWidth="150"
              field="carBrandSuitable"
              title="适用厂牌"
            ></vxe-column>
            <vxe-column
              minWidth="150"
              field="applicableModels"
              title="适用车型"
            ></vxe-column>
            <vxe-column minWidth="150" field="spec" title="规格"></vxe-column>
          </vxe-table>
          <!-- 分页 -->
          <div style="minwidth: 600px">
            <!-- <vxe-pager
              background
              align="right "
              size="medium"
              :current-page.sync="addPager.current"
              :page-size.sync="addPager.size"
              :page-sizes="[30]"
              :total="addPager.total"
              @page-change="addHandlePageChange"
              :layouts="[
                'PrevJump',
                'PrevPage',
                'Number',
                'NextPage',
                'NextJump',
                'Sizes',
                'FullJump',
                'Total'
              ]"
            >
              >
            </vxe-pager> -->

            <div
              style="display: flex; justify-content: right; padding-right: 16px"
            >
              <vxe-pager
                background
                align="right "
                size="medium"
                :current-page.sync="addPager.current"
                :page-size.sync="addPager.size"
                :page-sizes="[30]"
                :total="addPager.total"
                @page-change="addHandlePageChange"
                :layouts="[
                  'PrevJump',
                  'PrevPage',
                  'Number',
                  'NextPage',
                  'NextJump',
                  'Sizes',
                  'FullJump',
                  'Total'
                ]"
              >
              </vxe-pager>
              <span
                style="
                  height: 31px;
                  padding: 7px 10px;
                  border: 1px solid rgb(220, 222, 226);
                  border-radius: 4px;
                  margin-top: 8px;
                  line-height: 13px;
                "
                >30条/页</span
              >
            </div>
          </div>
        </div>
        <div v-if="addStatus == 2" class="addText">
          <h3>抱歉，未匹配到相应配件</h3>
          <p>请确认您输入的配件信息是否有误，若无您可以【申请配件】</p>
        </div>
      </div>
      <div slot="footer">
        <Button @click="addGoods = false">取消</Button>
      </div>
    </Modal>
    <!-- 批量新增的弹框 -->
    <Batchappend ref="Batchchild" @refush="refush"></Batchappend>
    <!-- 批量更新的弹框 -->
    <!-- Batchrenewal -->
    <Batchrenewal ref="popup" @refush="refush"></Batchrenewal>
    <!-- err同步商品 -->
    <Modal
      v-model="errMol"
      title="ERP商品同步"
      :mask-closable="false"
      footer-hide
      width="500px"
    >
      <div>
        <a
          href="https://img.g-part.cn/test/oms/2022/8/8/1659925980360_DAeIwna.xlsx"
          class="w120"
          >下载模板</a
        >
      </div>
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="90"
      >
        <FormItem label="上传文件:" prop="uploading">
          <Row>
            <div class="updatadq">
              <Input
                v-model="formValidate.uploading"
                style="width: 300px; margin-right: 10px"
              ></Input>
              <Col>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  action=""
                  :on-success="uploading"
                  :before-upload="handleUpload"
                >
                  <Button
                    style="color: #fff; background-color: #0074ff; border: none"
                    >浏览</Button
                  >
                </Upload>
              </Col>
            </div>
            <p>单次同步商品数量请不要超过1000条</p>
          </Row>
        </FormItem>
        <div v-if="renewalresult">
          <p class="fz14" style="padding-left: 10px"><b>同步结果:</b></p>
          <p class="fz14" style="padding-left: 10px">
            总计<span>{{ total1 }}</span
            >行
          </p>
          <p class="fz14" style="padding-left: 10px">
            同步成功<span>{{ succeed }}</span
            >行
          </p>
          <p class="fz14" style="padding-left: 10px">
            同步失败<span>{{ loser }}</span
            >行
            <!-- <span class="exportlose">(请导出更新失败商品清单)</span> -->
            <a class="w120" :href="loseinventory">（请导出新增失败商品清单）</a>
          </p>
        </div>
        <div style="width: 100%; text-align: center; margin-top: 20px">
          <Button
            style="
              background-color: #377cf1;
              color: #fff;
              border: none;
              margin-right: 20px;
            "
            :loading="loading"
            @click="handleSubmit('formValidate')"
            >确认</Button
          >
          <Button @click="errMol = false" style="margin-left: 20px"
            >取消</Button
          >
        </div>
      </Form>
    </Modal>
    <!-- 全局设置 -->
    <Modal
      v-model="allsz"
      title="全局设置"
      :closable="false"
      :mask-closable="false"
      footer-hide
      width="400px"
    >
      <div style="display: inline-block; padding-left: 40px">
        无货处理默认值 :
      </div>
      <RadioGroup v-model="disabledGroup" @on-change="setgoods">
        <Radio style="padding-left: 10px" label="1">下架</Radio>
        <Radio style="padding-left: 15px" label="2">变为询价</Radio>
      </RadioGroup>
      <div class="flex mt10">
        <Button type="primary" class="mr30" @click="setconfirm">确定</Button>
        <Button
          style="color: #377cf1; border: 1px solid #377cf1"
          @click="cancelsz"
          >取消</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import urlObj from '@/config/env.js'
import { dataMixin } from './dataMixin.js'
import Batchappend from '../../goodsManage/components/Batchappend.vue'
import Batchrenewal from '../../goodsManage/components/Batchrenewal.vue'
import {
  setsituation,
  getquerytion,
  getinit
} from '@/api/myweb/goods/goodsManage'
export default {
  mixins: [dataMixin],
  components: { Batchappend, Batchrenewal },
  data() {
    return {
      loser: '',
      succeed: '',
      total1: '',
      file: null, // 阻止上传
      loading: false, // 转圈
      renewalresult: false, // 更新的结果
      loseinventory: '', // 失败之后的地址的
      // 表单
      formValidate: {
        uploading: ''
      },
      // 规则
      ruleValidate: {
        uploading: [
          {
            required: true,
            message: '请上传文件',
            trigger: 'blur'
          }
        ]
      },
      importResult: '总计5行,同步成功3条,同步失败2条', //同步结果
      downUrl: '', // 模板下载地址
      errMol: false, //err同步商品弹框
      allsz: false,
      disabledGroup: '',
      tenantType: JSON.parse(localStorage.getItem('userdetails_tenantInfo'))
        .tenantType
    }
  },
  created() {},
  mounted() {
    this.screenHeight = document.body.clientHeight > 800 ? 620 : 440
    window.onresize = () => {
      return (() => {
        this.screenHeight = document.body.clientHeight > 800 ? 620 : 440
      })()
    }
    console.log(this.screenHeight)
  },
  methods: {
    // 全局确定
    async setconfirm() {
      const res = await setsituation({
        state: this.disabledGroup
      })
      if (res.status) {
        this.allsz = false
      }
    },
    // 全局取消
    cancelsz() {
      this.allsz = false
    },
    // 全局设置的变化
    setgoods(a) {
      console.log(a)
    },
    // 全局设置
    async overallset() {
      this.allsz = true
      // console.log(this.tenantType)
      // if (!this.tenantType) {
      //   this.disabledGroup = '1'
      // } else {
      //   this.disabledGroup = ''
      // }
      const res = await getquerytion()
      console.log(res)
      if (res.status) {
        this.disabledGroup = res.data
      }
    },
    // 批量新增
    Batchadd() {
      this.$refs.Batchchild.openBatch()
    },
    // 批量修改
    batchclick() {
      this.$refs.popup.openupdate()
    },
    // ere同步新增
    ERRopen() {
      console.log('11111')
      this.$refs.formValidate.resetFields()
      this.$refs.upload.clearFiles()
      this.errMol = true
      this.renewalresult = false
    },
    // 成功之后调用的钩子
    uploading(file) {
      if (file.code == 0) {
        this.$Message.success(file.message)
      } else {
        this.$Message.error(file.message)
      }
      console.log(file)
    },
    // 文件上传之前得钩子
    handleUpload(file) {
      console.log(file)
      this.formValidate.uploading = file.name
      this.file = file
      return false
    },
    // 确认
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.loading = true
          // console.log(this.file)
          let fd = new FormData()
          fd.append('file', this.file)
          const res = await getinit(fd)
          console.log(res)
          if (res.status) {
            this.renewalresult = true
            this.total1 = res.data.total
            this.succeed = res.data.succeed
            this.loser = res.data.loser
            this.loseinventory = res.data.filePath
          }
          // if (res.code == 0) {
          this.loading = false
          //   this.renewalresult = true
          //   this.total1 = res.data.total
          //   this.succeed = res.data.succeed
          //   this.loser = res.data.loser
          //   this.loseinventory = res.data.filePath
          //   this.$Message.destroy()
          //   this.$Message.success(res.message)
          //   this.$emit('refush')
        }
        // else {
        // this.loading = false
        // }
        // }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
.w120 {
  color: #377cf1;
}
.updatadq {
  display: flex;
}
</style>
